import {debounce} from '@helpers/utils'
import {Component} from 'lowkey-component';

import type {IField} from './BaseFormField';
import {BaseFormField} from './BaseFormField';

export class FormTextAreaField extends BaseFormField implements IField {
  private input: Component<HTMLTextAreaElement> | null =
    null;

  didMount() {
    super.didMount();
    this.input = new Component<HTMLTextAreaElement>(
        this.element?.querySelector('textarea') as HTMLTextAreaElement
    );
    this.input.mount()
    this.input.on('blur', this.onBlur.bind(this));
    this.input.on('keyup', debounce(this.onChange.bind(this), 200));
  }

  onChange() {
    super.onChange();
    if (this.input) {
      const height = this.input.element.scrollHeight
      this.input.element.style.height = `${height}px`
    }
  }

  set readonly(val: boolean) {
    val
      ? this.input?.element?.setAttribute('readOnly', 'true')
      : this.input?.element?.removeAttribute('readOnly');
  }

  get value(): string {
    return this.input?.element?.value || '';
  }

  get name() {
    return this.input?.element?.getAttribute('name') || '';
  }
}
